import React, { Component } from "react";
import { Container, Row, Col, Table, Form, Badge, Card } from "react-bootstrap";
import CommonRowId from "../components/CommonRowId";
import { OptionsConstants } from '../../config/constants/OptionsConstants';
import { formatNumber } from '../../library/utilitys';

class DataTableDashboardSecATrainee extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
        };
    }

    render = () => {

        let props = this.props;

        let { data, title, icon, bg = 'primary', column , type = '' } = props;
        let { loading } = this.state;
        const monthShort = OptionsConstants.variables.months.th.fn;
        
        return (
            <Card className="card-border mb-5">
                <Card.Header className={`card-header-action bg-${bg}`}>
                    <h6 className="text-white">{icon && <i className={`${icon} me-2`}></i>}{title}</h6>
                </Card.Header>
                <Card.Body style={{ minHeight: '350px', maxHeight: '350px', position: 'relative', overflowY: 'auto' }}>
                        <Col md={12}>
                            <Table
                                responsive
                                // borderless
                                className={`table-advance table-visible`}
                            >
                                <thead >
                                    <tr>
                                        {/* <th className="th-td-align-center th-width-50p"></th> */}
                                        <th>ชื่อหลักสูตร</th>
                                        {type === 'trained' && (
                                            <>
                                            <th className="th-td-align-center th-width-150p">จำนวนรุ่นที่อบรม (รวม)</th>
                                            <th className="th-td-align-center th-width-150p">จำนวนผู้เข้าอบรม (รวม)</th>
                                            </>
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.rows.map((row, index) => (
                                        <React.Fragment key={index}>
                                            <tr className={((index % 2) === 1) ? 'striped-row' : ''}>  
                                                {/* <td className="th-td-align-center">
                                                    <CommonRowId rowId={index + 1} />
                                                </td>                                                */}

                                                <td className="text-truncate" title={row.th_name}>
                                                    {row.th_name}
                                                </td>

                                                {type === 'trained' && (
                                                    <>
                                                    <td className="text-end text-center">
                                                        {formatNumber(row.model_no) || '-'}
                                                    </td>
                                                    <td className="text-end text-center">
                                                        {formatNumber(row.person_amount) || '-'}
                                                    </td>
                                                    </>
                                                )}
                                            </tr>

                                            <tr className="table-row-gap">
                                                <td colSpan={6} />
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </Table>

                        </Col>
                </Card.Body>
            </Card>
        );
    }
}

export default DataTableDashboardSecATrainee;